import React from 'react';
import { Button } from 'react-bootstrap';
import FileViewer from 'react-file-viewer';
import { Modal } from 'react-bootstrap';
import classnames from 'classnames';
import { Loading } from '../../components/shared';
import { saveByteArray_getUrl, base64ToArrayBuffer } from '../../utils/utilities';

class PDFLink extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0
        };
        this.handleNextPdf = this.handleNextPdf.bind(this);
        this.handlePrevPdf = this.handlePrevPdf.bind(this);
    }

    handleNextPdf = () => {
        let count = this.state.count;
        count++;
        this.setState({ count });
    };
    handlePrevPdf = () => {
        let count = this.state.count;
        count--;
        this.setState({ count });
    };

    render() {
        let data = this.props.pdfLink;
        var url = '';
        let arr = [];
        if (data) {
            data.split(',').forEach(file => {
                const fileArray = file.split('_');
                url = saveByteArray_getUrl(base64ToArrayBuffer(fileArray[0]), fileArray[1]);
                arr.push(url);
            });
        }

        const pdfSize = arr.length;

        return (
            <div>
                <Modal
                    show={this.props.show}
                    dialogClassName={classnames(['custom-modal-pdf', this.props.custom_class])}
                    onHide={this.props.onHide}
                >
                    <Modal.Header>
                        <div className="close-glyph">
                            <span
                                className="glyphicon glyphicon-remove"
                                aria-hidden="true"
                                onClick={this.props.onHide}
                            />
                        </div>
                    </Modal.Header>

                    <Modal.Body className="modal-body-custom">
                        {!this.props.loading && <Loading classes="loading centre-position" />}
                        {pdfSize > 2 ? (
                            <div className="pdfNavButtonBox">
                                <Button
                                    onClick={this.handlePrevPdf}
                                    disabled={this.state.count === 0}
                                >
                                    Previous
                                </Button>
                                <Button
                                    onClick={this.handleNextPdf}
                                    disabled={this.state.count >= pdfSize - 1}
                                >
                                    Next
                                </Button>
                            </div>
                        ) : (
                            <div>
                                {this.state.count != pdfSize - 1 && pdfSize == 2 && url && (
                                    <Button onClick={this.handleNextPdf}>Next</Button>
                                )}
                                {this.state.count > 0 && (
                                    <Button onClick={this.handlePrevPdf}>Previous</Button>
                                )}
                            </div>
                        )}
                        {this.props.loading && this.state.count >= 0 && data && (
                            <FileViewer
                                key={this.state.count}
                                fileType={'pdf'}
                                filePath={arr[this.state.count]}
                            />
                        )}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default PDFLink;
